import { EXAM_BASE_URL } from '@/helpers/constants'

export default {
	namespaced: true,
	state: {
		languages: [],
	},

	actions: {
		fetchSubjects({ commit, rootState }) {
			// return window.axios.get(`${EXAM_BASE_URL}/api/Subject/students/198/subjects`)
			return window.axios.get(`${EXAM_BASE_URL}/api/mobile/students/subjects`, {
				params: {
					centerId: rootState.login.activeUser.centerId,
					username: rootState.login.activeUser.userName
				}
			}).then((res) => {
				return res.data;
			})
		},

		fetchStatistics({ commit, rootState }) {
			// return window.axios.get(`${EXAM_BASE_URL}/api/examGrade/students/198/statistics`, {
			return window.axios.get(`${EXAM_BASE_URL}/api/mobile/students/statistics`, {
				params: {
					centerId: rootState.login.activeUser.centerId,
					username: rootState.login.activeUser.userName
				}
			}).then((res) => {
				return res.data;
			});
		},

		fetchMarks({ commit, rootState }, { conceptId }) {
			// return window.axios.get(`${EXAM_BASE_URL}/api/examGrade/students/${rootState.login.activeUser.userName}/marks-summary`, {
			return window.axios.get(`${EXAM_BASE_URL}/api/mobile/students/marks-summary`, {
				params: {
					centerId: rootState.login.activeUser.centerId,
					conceptId,
					username: rootState.login.activeUser.userName
				}
			}).then((res) => {
				return res.data;
			});
		}
	}
}